

import { CARRIER } from '../util/constants'

export default {
  data() {
    return{
      CARRIER
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    profile() {
      return this.$store.state.user.profile;
    }
  },
  methods: {
    isAllDetailsUpdated() {
      if(this.profile !== null) {
        if(this.profile.photoIdUrl === null || this.profile.driversLisenceBackPhotoUrl === null || this.profile.userHoldingLisencePhotoUrl === null || this.profile.addressProofPhotoUrl === null) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }
};
